import React from 'react';
import { useDashboardData } from './Dashboard';
import InfoTooltip from './InfoTooltip';

const CustomerSummary = () => {
  const { customers: data } = useDashboardData();

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <div className="detail-panel-title">
          <i className="fas fa-users me-2" style={{ color: '#8b5cf6' }}></i>
          Müşteri Özeti
          <InfoTooltip text="Role = CUSTOMER olan kullanıcıların istatistikleri. Yeni müşteriler son 30 gün, tekrarlayan müşteriler aktif aboneliği olanlar." />
        </div>
      </div>
      <div className="detail-panel-body">
        {!data ? (
          <div className="section-loading"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : (
          <>
            <div className="mini-stats-grid">
              <div className="mini-stat">
                <div className="mini-stat-value">{data.total}</div>
                <div className="mini-stat-label">
                  Toplam Müşteri
                  {data.tooltips?.total && <InfoTooltip text={data.tooltips.total} />}
                </div>
              </div>
              <div className="mini-stat">
                <div className="mini-stat-value" style={{ color: '#10b981' }}>+{data.new}</div>
                <div className="mini-stat-label">
                  Yeni (30 Gün)
                  {data.tooltips?.new && <InfoTooltip text={data.tooltips.new} />}
                </div>
              </div>
              <div className="mini-stat">
                <div className="mini-stat-value">{data.recurring}</div>
                <div className="mini-stat-label">
                  Aktif Abonelikli
                  {data.tooltips?.recurring && <InfoTooltip text={data.tooltips.recurring} />}
                </div>
              </div>
            </div>

            {/* Top Customers */}
            {data.topCustomers && data.topCustomers.length > 0 && (
              <div className="mt-3">
                <div className="small fw-semibold text-muted mb-2">En Değerli Müşteriler</div>
                <table className="dashboard-table">
                  <thead>
                    <tr>
                      <th>Müşteri</th>
                      <th>Sipariş</th>
                      <th>Harcama</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.topCustomers.slice(0, 5).map(c => (
                      <tr key={c.id}>
                        <td className="text-truncate" style={{ maxWidth: '120px' }}>{c.name}</td>
                        <td>{c.orderCount || c.subscriptionCount}</td>
                        <td className="fw-semibold">{c.totalSpent?.toLocaleString('tr-TR')} ₺</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerSummary;
